var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.badgeClasss },
    [
      _vm._t("default"),
      _vm._v(" "),
      !_vm.hidden
        ? _c(
            "span",
            {
              class: [_vm.dot ? "mku-badge__dot" : "mku-badge__value"],
              style: _vm.badgeStyle
            },
            [
              !_vm.dot && _vm.isShowText
                ? [_vm._v("\n      " + _vm._s(_vm.formatValue) + "\n    ")]
                : _vm._e()
            ],
            2
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }